import React from 'react';

export default function DeluxePaymentTabSkeleton({ variant = 'wallet' }) {
  if (variant === 'card') {
    return (
      <div className="deluxe-pay-skel" aria-hidden="true">
        <div className="deluxe-pay-skel__line deluxe-pay-skel__line--wide" />
        <div className="deluxe-pay-skel__row">
          <div className="deluxe-pay-skel__line" />
          <div className="deluxe-pay-skel__line" />
        </div>
        <div className="deluxe-pay-skel__btn" />
      </div>
    );
  }

  return (
    <div className="deluxe-pay-skel deluxe-pay-skel--wallet" aria-hidden="true">
      <div className="deluxe-pay-skel__btn deluxe-pay-skel__btn--wallet" />
    </div>
  );
}
